import { getCompanyCompanyIdBankDetail } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const getCompanyBankDetailListQueryKey = (companyId: number) => {
	return ["COMPANY_BANK_DETAIL_LIST", companyId];
};

export function useCompanyBankDetailListQuery(companyId: number) {
	return useQuery({
		queryKey: getCompanyBankDetailListQueryKey(companyId),
		queryFn: processResponse(() => getCompanyCompanyIdBankDetail(companyId)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!companyId,
	});
}
